import type {PreSendCollector} from './index';
import {getAskAIExtraPageContext} from '../ask-ai-store';


export const askAIExtraPageContextCollector: PreSendCollector = {
  id: 'askai-extra-page-context',
  collect: async () => {
    const extra = getAskAIExtraPageContext();
    if (!extra || Object.keys(extra).length === 0) {
      return;
    }
    // merged into `context.page_context` by caller
    return {...extra};
  },
};
